import { P2GRadio } from '@parcel2go/core-ui';
import { P2GGrid } from '@parcel2go/core-ui';
import SidePanelSection from '../../../../../../components/sidepanel-section';
import { P2GText } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  productNames: { text: string; value: string }[];
  selected: string;
  onChange: (v: string) => void;
}

export const QuoteProductNameFilter: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  return (
    props.productNames?.length > 1 && (
      <SidePanelSection title={t('SERVICE_CATEGORIES_SUBTITLE', { defaultValue: 'Service Categories' })}>
        <P2GGrid container direction="column">
          {props.productNames.map((p) => (
            <P2GGrid item key={p.value}>
              <P2GRadio
                onChange={() => props.onChange(p.value)}
                id="Tags"
                value={props.selected}
                name="Service Categories"
                checked={props.selected === p.value}
                label={<P2GText variant="body2">{p.text}</P2GText>}
              />
            </P2GGrid>
          ))}
        </P2GGrid>
      </SidePanelSection>
    )
  );
};
